import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/RectanglePortraitStackFill.tsx
const RectanglePortraitStackFillIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M5 21.5a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M9.623 3.432a2.001 2.001 0 0 1 2.45-1.415l8.694 2.33a2 2 0 0 1 1.414 2.45l-3.107 11.59a1.998 1.998 0 0 1-1.923 1.48V6.7a2.2 2.2 0 0 0-2.2-2.2H9.337l.286-1.068Z",
		fill: props.fill || "currentColor"
	})]
}));
//#endregion
export { RectanglePortraitStackFillIcon };
